import { render, staticRenderFns } from "./open-miniprogram.vue?vue&type=template&id=ed773448&scoped=true&"
import script from "./open-miniprogram.vue?vue&type=script&lang=js&"
export * from "./open-miniprogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed773448",
  null
  
)

export default component.exports